import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { makeGetCsv } from '../make-api'

const REPORT_BENOIT = '/ReportBenoit'

const reportBenoitApiLegacy = makeGetCsv(REPORT_BENOIT)

async function downloadReportBenoit() {
  const apiClient = getApiClient()
  return reportBenoitApiLegacy(apiClient)
}

export function useReportBenoitExport(): [MutationFunction<void, void>, boolean] {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: downloadReportBenoit,
  })

  return [mutateAsync, isPending]
}

